import { render, staticRenderFns } from "./RemoteEdit.vue?vue&type=template&id=dba537c6"
import script from "./RemoteEdit.vue?vue&type=script&lang=js"
export * from "./RemoteEdit.vue?vue&type=script&lang=js"
import style0 from "./RemoteEdit.vue?vue&type=style&index=0&id=dba537c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports